import { APP_CACHE_TAG_FIELDS_OF_WORK, APP_CACHE_TAG_PROJECTS } from "@/lib/constants";
import { ApiResponseError } from "@/lib/error";
import { api } from "@/openapi/client";
import type { components, operations } from "@/openapi/generated";

export type FieldOfWorkDto = components["schemas"]["FieldOfWorkDto"];

/**
 * Fetch the full list of fields of work from the backend, sorted by title (de-DE).
 */
export async function getAllFieldsOfWork(
    client: typeof api = api
): Promise<FieldOfWorkDto[]> {
    const { data, error } = await client.GET("/fields-of-work", {
        next: { revalidate: 36000, tags: [APP_CACHE_TAG_FIELDS_OF_WORK] },
    });
    if (error) throw error;
    if (!data) throw new ApiResponseError("getAllFieldsOfWork");
    return [...data].sort((a, b) => a.title.localeCompare(b.title, "de-DE"));
}

/**
 * Fetch paginated projects filtered by field of work id.
 */
export type ProjectsByFieldOfWorkResponse =
    operations["getCertifiedProjectsByField"]["responses"]["200"]["content"]["*/*"];

export async function getProjectsByFieldOfWorkId(
    fieldOfWorkId: string,
    page = 0,
    size = 20,
    client: typeof api = api
): Promise<ProjectsByFieldOfWorkResponse> {
    const { data, error } = await client.GET("/projects/withAssociations/byFieldOfWork", {
        params: { query: { fieldOfWorkId, page, size } },
        next: {
            revalidate: 36000,
            tags: [APP_CACHE_TAG_FIELDS_OF_WORK, APP_CACHE_TAG_PROJECTS],
        },
    });
    if (error) throw error;
    if (!data) throw new ApiResponseError("getProjectsByFieldOfWorkId");
    return data;
}
